import { create } from 'zustand';

/**
 * Non-boolean runtime config that has no API source (the `Config/GetAppConfig` endpoint
 * was never built). Currently just the "Turlar" iframe URLs. Seeded from build-time env
 * vars; the store shape is kept so `TourIframePage` (and its test) can read/override it.
 * Boolean feature flags live in `featureFlags.ts` (hardcoded).
 */
export interface TourUrls {
  international?: string;
  cruise?: string;
  cultural?: string;
  cyprus?: string;
}

function envTourUrls(): TourUrls | null {
  const urls: TourUrls = {
    international: process.env.REACT_APP_TOUR_URL_INTERNATIONAL || undefined,
    cruise: process.env.REACT_APP_TOUR_URL_CRUISE || undefined,
    cultural: process.env.REACT_APP_TOUR_URL_CULTURAL || undefined,
    cyprus: process.env.REACT_APP_TOUR_URL_CYPRUS || undefined,
  };
  return Object.values(urls).some(Boolean) ? urls : null;
}

interface AppConfigState {
  tourUrls: TourUrls | null;
}

export const useAppConfigStore = create<AppConfigState>(() => ({
  tourUrls: envTourUrls(),
}));
